export enum SearchValueType {
  Guid = 'Guid',
  String = 'String',
  Email = 'Email',
  Number = 'Number',
  Date = 'Date',
  DateRange = 'DateRange',
  Boolean = 'Boolean',
  MultiValue = 'MultiValue',
  Skill = 'Skill',
  List = 'List',
  WorkspaceMultiValue = 'WorkspaceMultiValue',
  EvaluationAggregateMultiValue = 'EvaluationAggregateMultiValue',
  EvaluationAggregateString = 'EvaluationAggregateString',
  EmptyOperator = 'EmptyOperator',
  Payment = 'Payment',
}
